const config = require('../../../json/config.json');
const svgConfig = require('../../../json/svg.json');

import { doorSettingsStateStore } from '../../../assets/scripts/service/redux-service';
import { loadDoorSettingsState } from '../../../assets/scripts/service/localStorage-service';
const aaecState = require('../../../json/state/aaec-state.json');

export const onOffSwitchCheckbox = (() => {

    let doorState = aaecState;
	if (loadDoorSettingsState() !== undefined) {
		doorState = loadDoorSettingsState();
    }

    if ( doorState.unit == "imperial" ) {
        $('.unit-picker.switch-input', '.modal' ).prop('checked', true);
    }

})();


// WEBPACK FOOTER //
// ./src/components/inputs/on-off-switch/on-off-switch.js